import { useState, useEffect } from "react";
import axios from "axios";
import { Container, Table, Button, Spinner } from "react-bootstrap";
import ModalCrud from "./ExamModal";
import { DoLogout } from "../Utils";

export default function BulkProcessExams(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const displayFormat = "DD/MM/YYYY";
  var moment = require("moment");

  const [isLoading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [exams, setExams] = useState([]);
  const [examDetail, setExamDetail] = useState(null);
  const [dojos, setDojos] = useState([]);
  const [grades, setGrades] = useState([]);
  const [teachers, setTeachers] = useState([]);

  const token = JSON.parse(ls.get("jwt"));

  useEffect(() => {
    GetExams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const GetExams = async () => {
    setLoading(true);

    const dojos = await axios
      .get(
        `${API_URL}/dojos?sort[0]=name%3Aasc&fields[0]=id&fields[1]=name&pagination[pageSize]=1000`,
        headerRequest
      )
      .catch((error) => {
        console.log("Error with dojos:", error);
        if (error.response.status === 401) DoLogout();
      });
    setDojos(dojos.data.data);

    const grades = await axios.get(
      `${API_URL}/grades?sort[0]=id%3Aasc&fields[0]=id&fields[1]=name`,
      headerRequest
    );
    setGrades(grades.data.data);

    const teachers = await axios.get(
      `${API_URL}/teachers/?sort[0]=name%3Aasc&populate=user`,
      headerRequest
    );
    setTeachers(teachers.data.data);

    const res = await axios.get(
      `${API_URL}/temp-exams?populate=tempUser,examination.examiner&sort[0]=docNumber%3Aasc&filters[state][$eq]=NEW&pagination[pageSize]=1000`,
      headerRequest
    );
    const exams = res.data.data;

    Promise.all(
      exams.map(async (exam) => {
        exam.grade = GetGradeName(grades.data.data, exam.attributes.grade_id);
        if (!exam.grade || exam.grade === "") {
          exam.grade = `No existe (${exam.attributes.grade_id})`;
        }
        exam.dojo = GetDojoName(dojos.data.data, exam.attributes.dojo_id);
        if (!exam.dojo || exam.dojo === "") {
          exam.dojo = `No existe (${exam.attributes.dojo_id})`;
        }

        const res = await axios.get(
          `${API_URL}/users/?filters[docNumber][$eq]=${exam.attributes.docNumber}`,
          headerRequest
        );
        const user = res.data[0];
        if (user) {
          exam.userId = user.id;
          exam.fullname = user.lastname + ", " + user.name;
        } else {
          exam.fullname = `No existe`;
        }

        const resCreated = await axios.get(
          `${API_URL}/users/${exam.attributes.createdByUser}`,
          headerRequest
        );
        const userCreated = resCreated.data;
        if (userCreated) {
          exam.createdByUserName =
            userCreated.name + " " + userCreated.lastname;
        } else {
          exam.createdByUserName = `No existe`;
        }

        // Si es un una reserva de examen aprobada debe usarse el link de la fecha de reserva
        // y cargar el examinador y fecha de esa reserva
        // porque exam.responsibleDocNumber tiene el instructor responsable
        if (exam.attributes.examination?.data?.attributes.examiner?.data?.id) {
          const res2 = await axios.get(
            `${API_URL}/teachers/${exam.attributes.examination.data.attributes.examiner.data.id}`,
            headerRequest
          );
          if (res2.data.data?.id) {
            exam.responsibleId = res2.data.data.id;
            exam.responsibleName = res2.data.data.attributes.name;
            exam.attributes.date =
              exam.attributes.examination.data.attributes.date;
          } else {
            exam.responsibleName = `No existe (${exam.attributes.examination.data.attributes.date})`;
          }
        } else {
          const res2 = await axios.get(
            `${API_URL}/teachers/?filters[docNumber][$eq]=${exam.attributes.responsibleDocNumber}`,
            headerRequest
          );
          const responsible = res2.data.data[0];
          if (responsible) {
            exam.responsibleId = responsible.id;
            exam.responsibleName = responsible.attributes.name;
          } else {
            exam.responsibleName = `No existe (${exam.attributes.responsibleDocNumber})`;
          }
        }

        if (moment(exam.attributes.date, true).isValid() !== true) {
          exam.attributes.date = `Inválida. (${exam.attributes.date})`;
        } else if (
          moment().diff(moment(exam.attributes.date, true), "minutes") < 0
        ) {
          exam.attributes.date = `Futura. (${exam.attributes.date})`;
        }

        exam.result = "A procesar";

        return exam;
      })
    ).then((exams) => {
      setExams(exams);
      setLoading(false);
    });
  };

  function GetDojoName(dojos, dojoId) {
    //console.log(`GetDojoName for: ${dojoId} in #${dojos.length} dojos`);
    const result = dojos.find(({ id }) => id == dojoId);
    return result?.attributes?.name;
  }

  function GetGradeName(grades, gradeId) {
    //console.log(`GetGradeName for: ${gradeId} in #${grades.length} dojos`);
    const result = grades.find(({ id }) => id == gradeId);
    return result?.attributes?.name;
  }

  function GetError(error) {
    return error.response
      ? "ERROR: " + error.response.data?.error?.message
      : "ERROR: " + error.mesage;
  }

  const processData = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Procesar todos los items pendientes
    for (let i = 0; i < exams.length; i++) {
      const item = exams[i];

      // Validar en base a lo cargado
      if (!item.userId) {
        exams[i].result = "ERROR: DocNumber no existe";
        continue;
      }
      if (moment(item.attributes.date, true).isValid() !== true) {
        exams[i].result = "ERROR: Fecha es inválida";
        continue;
      }
      if (
        item.attributes.dateAikikai != "" &&
        moment(item.attributes.date, true).diff(
          moment(item.attributes.dateAikikai, true),
          "days"
        ) > 0
      ) {
        exams[i].result = "ERROR: Fecha Aikikai es menor a Examen";
        continue;
      }
      if (!item.grade) {
        exams[i].result = "ERROR: Graduacion no existe";
        continue;
      }
      if (!item.dojo) {
        exams[i].result = "ERROR: Dojo no existe";
        continue;
      }
      if (!item.responsibleName) {
        exams[i].result = "ERROR: Responsable no existe";
        continue;
      }

      let isError = false;
      /* consultar el user con los datos de examenes, 
           buscar si existe el examen a procesar 
           y actualizarlo sino agregarlo
        */
      const u = await axios
        .get(`${API_URL}/users/${item.userId}`, headerRequest)
        .catch((error) => {
          isError = true;
          exams[i].result = GetError(error);
        });
      if (isError) continue;

      let reqUser = u.data;
      let userExams = reqUser.exams;
      if (!userExams) userExams = [];

      let processToBeMade = "CREATED";
      const examToUpdateIdx = userExams.findIndex((e) => {
        if (e.grade.id == item.attributes.grade_id) {
          processToBeMade = "UPDATED";
          return true;
        }
        return false;
      });

      if (examToUpdateIdx >= 0) {
        userExams[examToUpdateIdx].date = item.attributes.date;
        const tmpDateJapon = item.attributes.dateAikikai;
        if (tmpDateJapon && tmpDateJapon !== "" && tmpDateJapon !== null) {
          userExams[examToUpdateIdx].dateAikikai = tmpDateJapon;
        }
        const tmpIdJapon = item.attributes.idAikikai;
        if (tmpIdJapon && tmpIdJapon !== "" && tmpIdJapon !== null) {
          userExams[examToUpdateIdx].idAikikai = tmpIdJapon;
        }
        userExams[examToUpdateIdx].grade = item.attributes.grade_id;
        userExams[examToUpdateIdx].dojo = item.attributes.dojo_id;
        userExams[examToUpdateIdx].examiner = item.responsibleId;
        userExams[examToUpdateIdx].state = "APPROVED";
      } else {
        const newExam = {
          date: item.attributes.date,
          dateAikikai: item.attributes.dateAikikai,
          idAikikai: item.attributes.idAikikai,
          grade: item.attributes.grade_id,
          dojo: item.attributes.dojo_id,
          examiner: item.responsibleId,
          state: "APPROVED",
        };
        userExams.push(newExam);
      }
      reqUser.exams = userExams;

      //console.log(`PUT /users/${item.userId}`);
      //console.log({ reqUser });

      await axios
        .put(`${API_URL}/users/${item.userId}`, reqUser, headerRequest)
        .catch((error) => {
          isError = true;
          console.log("Error with put users:", error.response);
          exams[i].result = GetError(error);
        });
      if (isError) continue;

      // Una vez actualizado el usuario, marcar el temp como procesado
      const reqTempExam = {
        data: {
          state: processToBeMade,
        },
      };
      await axios
        .put(`${API_URL}/temp-exams/${item.id}`, reqTempExam, headerRequest)
        .catch((error) => {
          isError = true;
          console.log("Error with post temp-exams:", error.response);
          exams[i].result = GetError(error);
        });
      if (isError) continue;

      exams[i].result = "OK";
    }
    setExams(exams.filter((e) => e.result !== "OK"));
    setLoading(false);
  };

  const EditExam = (data) => {
    setExamDetail(data);
    setShowModal(true);
  };

  const renderData = (
    <>
      <Table
        striped
        hover
        size="sm"
        responsive="sm"
        style={{ fontSize: ".8em" }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>DNI</th>
            <th>Nombre</th>
            <th>Grad.</th>
            <th>Fecha</th>
            <th>Examinador</th>
            <th>Dojo</th>
            <th>Alta</th>
            <th>Resultado</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {exams.length < 1 ? (
            <tr>
              <td colSpan="10" align="center">
                No hay exámenes pendientes de procesar.
              </td>
            </tr>
          ) : (
            exams.map((exam) => (
              <tr key={exam.id}>
                <td align="center">{exam.id}</td>
                <td align="center">
                  {exam.attributes.docNumber} ({exam.userId})
                </td>
                <td align="left">{exam.fullname}</td>
                <td align="center">{exam.grade}</td>
                <td align="center">
                  {moment(exam.attributes.date).format(displayFormat)}
                </td>
                <td align="center">{exam.responsibleName}</td>
                <td align="left">{exam.dojo}</td>
                <td align="center">{exam.createdByUserName}</td>
                <td align="left">{exam.result}</td>
                <td align="center">
                  <Button
                    size="sm"
                    className="btn-xs"
                    onClick={() => EditExam(exam)}
                    variant="warning"
                  >
                    Editar
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      <Button
        size="sm"
        variant="success"
        onClick={(e) => {
          processData(e);
        }}
      >
        PROCESAR
      </Button>
      {showModal && (
        <div
          onClick={() => setShowModal(false)}
          className="modal-background"
        ></div>
      )}
      {showModal && (
        <ModalCrud
          show={showModal}
          exam={examDetail}
          grades={grades}
          dojos={dojos}
          teachers={teachers}
          onHide={(saved) => {
            setShowModal(false);
            if (saved === true) GetExams();
          }}
        />
      )}
    </>
  );

  return (
    <Container className="p-3 mb-4 bg-light rounded-3">
      <h4>PROCESAR EXÁMENES</h4>
      <p>Revise la lista de pendientes y presione Procesar</p>
      {isLoading ? <Spinner animation="border" /> : renderData}
    </Container>
  );
}
